import { AppBar, Box, Button, CircularProgress, ClickAwayListener, FormControl, IconButton, InputBase, MenuItem, MenuList, NativeSelect, Paper, Popover, Popper, Select, TextField, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { erpResultsPageLink, Icons, isMobileDevice, secondsToHMS } from '../../utils/utilities'
import GlobalLanguageSelector from '../../components/GlobalLanguageSelector'
import { useLayoutContext } from '../../contexts/layout.context'
import { useThemeContext } from '../../contexts/theme.context'
import completedImg from '../../assets/completed.svg'
import { useUserStore } from '../../store/user.store'
import { themeOptions } from '../../themes/themes'
import aliveLogo from '../../assets/alivelogo.png'
import api from '../../service/api'
import AlreadyAttempted from '../../components/admission-exam-components/candidate-attempt-info-blocks/AlreadyAttempted'
import AlreadyQualified from '../../components/admission-exam-components/candidate-attempt-info-blocks/AlreadyQualified'
import ReattemptRequested from '../../components/admission-exam-components/candidate-attempt-info-blocks/ReattemptRequested'
import ReattemptRequestApproved from '../../components/admission-exam-components/candidate-attempt-info-blocks/ReattemptRequestApproved'



const navigateToResultsPage = () => {
    window.location.href = `${erpResultsPageLink}?candidate_id=${encodeURIComponent( localStorage.getItem( 'admission_exam_candidate_id' ) )}`
}

const Navbar = () => {

    const [anchorEl, setAnchorEl] = useState( null )
    const [settingsAnchorEl, setSettingsAnchorEl] = useState( null )

    const open = Boolean( anchorEl )

    const navigate = useNavigate()
    const { navHeight } = useLayoutContext()

    const { palette } = useTheme()
    const { setSelectedTheme, selectedTheme } = useThemeContext()

    const handleThemeChange = e => {
        setSelectedTheme( e.target.value )
        localStorage.setItem( 'preferedTheme', e.target.value )
        setSettingsAnchorEl( null )
    }

    return (
        <AppBar
            id="appbar"
            elevation={0}
            sx={{
                borderBottom: palette.grey[600] + " 1px solid",
                borderRadius: "0",
                background: palette.background.paper,
                transition: "0.2s ease-out",
                position: "static",
                color: "black",
                height: "fit-content",
                zIndex: "1220"
            }}
        >
            <Box alignItems="center" justifyContent="space-between" height={`${navHeight}px`} paddingRight={"20px"} display="flex" maxWidth="100%" id="app-bar" sx={{ transition: "0.2s ease-out", paddingLeft: "20px" }}>
                <Box display="flex" gap="10px" alignItems="center">
                    <Box component="img" width={{ md: "30px", xs: "25px" }} src={aliveLogo} alt="Logo" />
                    <Typography variant="h6" fontWeight={500} fontSize={{ md: "16px", xs: "14px", sm: "16px" }}>Alive Admission Exams</Typography>
                </Box>
                {<Box display="flex" alignItems="center" gap="10px">
                    <GlobalLanguageSelector variant='dark' />
                    {/* <Tooltip placement="bottom" title="Theme">
                        <IconButton sx={{ gap: 1, borderRadius: "10px", border: `1px solid ${palette.text.secondary}` }} size='small' onClick={( e ) => setSettingsAnchorEl( e.currentTarget )}>
                            {selectedTheme === "dark" ? Icons.default.DarkMode : selectedTheme === "system" ? Icons.default.SystemTheme : Icons.default.LightMode}
                            {Icons.default.DropDown}
                        </IconButton>
                    </Tooltip> */}

                    <Popper placement='bottom-end' sx={{ zIndex: 20000 }} open={Boolean( settingsAnchorEl )} anchorEl={settingsAnchorEl}>
                        <ClickAwayListener onClickAway={() => setSettingsAnchorEl( null )} >
                            <Box component={Paper}>
                                <MenuList>
                                    {themeOptions.map( theme => (
                                        <MenuItem onClick={() => { setSelectedTheme( theme ); setSettingsAnchorEl( null ) }} key={theme} value={theme} dense sx={{ fontSize: "14px", textTransform: "capitalize" }}>{theme}</MenuItem>
                                    ) )}
                                </MenuList>
                            </Box>
                        </ClickAwayListener>
                    </Popper>
                </Box>}
            </Box>
        </AppBar>
    )
}

const OTPExpiryTimer = ( { expiresAt, setOtpExpired } ) => {

    const [timeLeft, setTimeLeft] = useState( expiresAt - new Date() )

    useEffect( () => {
        const timer = setInterval( () => {
            const newTimeLeft = expiresAt - new Date()
            if ( newTimeLeft <= 0 ) {
                clearInterval( timer )
                setOtpExpired( true )
                setTimeLeft( 0 )
            } else {
                setTimeLeft( newTimeLeft )
            }
        }, 1000 )

        return () => clearInterval( timer )
    }, [expiresAt, setOtpExpired] )

    if ( timeLeft <= 0 ) {
        return <Typography variant='subtitle2' color='error' sx={{ fontSize: "12px" }} gutterBottom >OTP has expired!</Typography>
    }

    return (
        <Typography variant='subtitle2' color='textSecondary' sx={{ fontSize: "12px" }} gutterBottom >OTP expires in: {secondsToHMS( timeLeft / 1000, false )}</Typography>
    )
}

export default function CandidatePublicAdmissionExam () {

    const [errors, setErrors] = useState( { name: null, phoneNumber: null, otp: null } )
    const [showRequestRetryButton, setShowRequestRetryButton] = useState( false )
    const [checkingEligibility, setCheckingEligibility] = useState( false )
    const [verificationDetails, setVerificationDetails] = useState( null )
    const [verifyingOtp, setVerifyingOtp] = useState( false )
    const [attempting, setAttempting] = useState( false )
    const [submitting, setSubmitting] = useState( false )
    const [otpExpired, setOtpExpired] = useState( true )
    const [otp, setOtp] = useState( ["", "", "", ""] )
    const [mode, setMode] = useState( "registration" )
    const [modeData, setModeData] = useState( {} )
    const [program, setProgram] = useState( 1 )
    const [phone, setPhone] = useState( "" )
    const [name, setName] = useState( "" )

    const UserStore = useUserStore()

    const { palette, border } = useTheme()
    const { t } = useTranslation()
    const navigate = useNavigate()


    const AVAILABLE_PROGRAMS = [
        { label: t( "program.btech" ), value: 1 },
        { label: t( "program.bca" ), value: 5 },
        { label: t( "program.bba" ), value: 7 }
    ]

    const [searchParams] = useSearchParams()

    const validateName = ( value ) => {
        if ( !value?.trim() ) {
            setErrors( prev => ( { ...prev, name: t( 'candidateLogin.nameRequired' ) } ) )
            return false
        } else {
            setErrors( prev => ( { ...prev, name: null } ) )
            return true
        }
    }

    const validatePhoneNumber = ( value ) => {

        if ( !value?.trim() ) {
            setErrors( prev => ( { ...prev, phoneNumber: t( 'candidateLogin.phoneRequired' ) } ) )
            return false
        } else if ( !value.match( /^\d{9}$/ ) ) {
            setErrors( prev => ( { ...prev, phoneNumber: t( 'candidateLogin.invalidPhone' ) } ) )
            return false
        } else {
            setErrors( prev => ( { ...prev, phoneNumber: null } ) )
            return true
        }
    }

    const validateOtp = otpValue => {
        console.log( otpValue, typeof otpValue === 'string', otpValue.match( /^\d{4}$/ ) )

        return Boolean( otpValue && typeof otpValue === 'string' && otpValue.match( /^\d{4}$/ ) )
    }

    const copyContactNumber = () => {
        navigator.clipboard.writeText( `+998553010009` )
            .then( () => {
                console.log( "Text copied to clipboard successfully!" )
            } )
            .catch( err => {
                console.error( "Failed to copy text: ", err )
            } )
    }

    const handleNameChange = event => {
        const value = event.target.value

        setName( value )

        if ( errors.name )
            setErrors( prev => ( { ...prev, name: value ? null : t( 'candidateLogin.nameRequired' ) } ) )
    }

    const handlePhoneNumberChange = event => {
        const value = event.target.value

        if ( value.match( /^\d+$/ ) )
            setPhone( value )
        else if ( !value )
            setPhone( "" )

        if ( errors.phoneNumber )
            validatePhoneNumber( value )
    }

    const handleOtpChange = ( event, otpIndex ) => {

        let newVal = [...otp]
        let moveToNextInput = false
        const val = event.target.value?.trim()
        if ( val || +val === 0 ) {
            if ( val.match( /^\d$/ ) ) {
                newVal[otpIndex] = val
                moveToNextInput = true
            } else if ( otpIndex === 0 && val.match( /^\d{4}$/ ) ) {
                newVal = val.split( "" )
                moveToNextInput = false
                handleOtpVerification( null, val )
            }
        } else {
            newVal[otpIndex] = ""
        }
        setOtp( newVal )

        if ( moveToNextInput ) {
            const nextInput = document.getElementById( `otp-input-${otpIndex + 1}` )
            if ( nextInput )
                nextInput?.focus()
            else
                handleOtpVerification( null, newVal.join( "" ) )
        }
    }

    const attempt = async ( id ) => {
        try {
            setCheckingEligibility( true )
            const { data: { eligible, exceedsMaximumNumberOfAttempts, message, restrictMobileAttempt } } = await api.admissionExams.checkCandidateEligibilityForExam( id )
            if ( exceedsMaximumNumberOfAttempts ) {
                return toast( message ? t( `message.${message}` ) : t( 'message.maxAttemptReached' ) )
            }
            if ( restrictMobileAttempt ) {
                const { isMobile } = isMobileDevice()
                if ( isMobile )
                    return toast( t( "message.unsupportedDevice" ) )
            }
            setCheckingEligibility( true )

            if ( eligible ) {
                setAttempting( true )
                const { status, data } = await api.admissionExams.attempt( id )
                if ( status === 200 ) {
                    if ( !data.isNewParticipation )
                        toast( t( "message.notNewAttempt" ), { containerId: "main" } )
                    const url = `/admission-exam/${id}/${data.participation_id}/attempt/${data.attempt}`

                    navigate( url )
                }
            } else {
                toast( message ? t( `message.${message}` ) : t( "message.alreadyPassed" ) )
            }
        } catch ( e ) {
            navigate( `/admission-exams` )
            console.log( e )
            toast( e?.response?.data?.message || e?.response?.data || "Something went wrong", { containerId: "main" } )
        } finally {
            setAttempting( false )
            setCheckingEligibility( false )
        }
    }

    const requestOtpResend = async () => {
        try {
            const { data: { data } } = await api.admissionExams.resendOTP( { verification_id: verificationDetails.id } )
            setVerificationDetails( data )
            setOtpExpired( false )
            toast.success( t( 'candidateLogin.resentSuccessful' ) )
        } catch ( err ) {
            console.log( err )
            toast.error( err?.response?.data?.message ? t( err?.response?.data?.message ) : t( 'candidateLogin.fallbackResendErrorMessage' ) )
        }
    }

    const handleRegister = async ( event ) => {
        try {
            event.preventDefault()

            if ( validateName( name ) && validatePhoneNumber( phone ) ) {
                setSubmitting( true )
                const { data: { candidateDetails, alreadyQualified, exceedsMaximumNumberOfAttempts, message, restrictMobileAttempt, verification, alreadyAttempted, reattemptRequested } } = await api.admissionExams.verifyCandidateEligibilityForExam( { full_name: name.trim(), phone_number: "998" + phone, program_id: program } )

                if ( exceedsMaximumNumberOfAttempts && !alreadyQualified ) {
                    return toast( t( 'message.maxAttemptReached' ) )
                }
                if ( exceedsMaximumNumberOfAttempts && alreadyQualified ) {
                    setModeData( candidateDetails )
                    return setMode( "already-qualified" )
                }
                if ( alreadyAttempted ) {
                    if ( reattemptRequested )
                        return setMode( "reattempt-requested" )
                    return setMode( "already-attempted" )
                }
                setVerificationDetails( verification )
                setOtpExpired( false )
                setMode( "otp-verification" )
            }
        } catch ( err ) {
            console.log( err )
            if ( err?.response?.status === 404 )
                return toast.error( t( 'message.examNotExists' ) )
            toast.error( t( err?.response?.data?.message || 'candidateLogin.registrationFallBackError' ) )
        }
        finally {
            setSubmitting( false )
        }
    }

    const handleOtpVerification = async ( event, forcedOtpValue ) => {
        try {
            event?.preventDefault()

            const otpValue = forcedOtpValue ?? otp.join( "" )
            if ( validateOtp( otpValue ) ) {
                setErrors( prev => ( { ...prev, otp: null } ) )
            } else {
                setErrors( prev => ( { ...prev, otp: t( 'candidateLogin.invalidOtp' ) } ) )
                return
            }
            setVerifyingOtp( true )

            const stringifiedUtmDetails = localStorage.getItem( "utm_details" ) || ""
            let utmDetails = {}
            if ( stringifiedUtmDetails?.trim() ) {
                try {
                    utmDetails = JSON.parse( stringifiedUtmDetails )
                } catch ( err ) {
                    utmDetails = {}
                }
            }
            const { data: { token, exam_id } } = await api.admissionExams.verifyCandidatePhoneNumber( { utm_details: utmDetails, verification_id: verificationDetails.id, full_name: name, phone_number: "998" + phone, otp: otpValue, program_id: program } )
            localStorage.setItem( "admission_exam_candidate_id", "998" + phone )
            localStorage.setItem( "id_token", token )
            await attempt( exam_id )
        } catch ( err ) {

            const { expired } = err?.response?.data || {}
            if ( expired ) {
                setMode( "registration" )
                setOtp( ["", "", "", ""] )
            }
            toast.error( t( err?.response?.data?.message || 'candidateLogin.otpVerificationFallbackError' ) )
        } finally {
            setVerifyingOtp( false )
        }
    }

    const handleReattemptRequest = async () => {
        setSubmitting( true )
        try {
            await api.admissionExams.requestReattempt( { user_id: "998" + phone } )
            setMode( "reattempt-requested" )
        } catch ( err ) {

            const { restart, attemptNotFound, reattemptApproved } = err?.response?.data || {}
            if ( reattemptApproved ) {
                return setMode( "reattempt-approved" )
            }
            if ( restart || attemptNotFound ) {
                setMode( "registration" )
                setOtp( ["", "", "", ""] )
                if ( attemptNotFound )
                    toast.error( t( 'candidateLogin.noPreviousAttempt' ) )
            } else
                toast.error( err?.response?.data?.message ? t( err?.response?.data?.message ) : t( 'candidateLogin.reattemptRequestFallbackError' ) )
        } finally {
            setSubmitting( false )
        }
    }

    useEffect( () => {

        const preFillNameAndPhoneIfAvailable = async () => {
            const { user_name, user_id, program_id } = UserStore.getUser
            if ( !user_name && !user_id ) {
                await UserStore.fetchUser( { userType: 'candidate', skipToast: true } )
                const { user_name, user_id } = UserStore.getUser
                if ( user_name )
                    setName( user_name )
                if ( user_id && user_id.match( /^\d{12}$/ ) )
                    setPhone( user_id.substring( 3 ) )

            } else {
                if ( user_name )
                    setName( user_name )
                if ( user_id && user_id.match( /^\d{12}$/ ) )
                    setPhone( user_id.substring( 3 ) )
            }

            if ( program_id && [1, 5, 7].includes( +program_id ) )
                setProgram( +program_id )

        }

        preFillNameAndPhoneIfAvailable()
    }, [UserStore] )

    useEffect( () => {
        const stringifiedUtms = searchParams.toString()

        if ( searchParams.size > 0 ) {

            const utmObject = Object.fromEntries( searchParams.entries() )

            let utmData = {}

            try {
                utmData = JSON.parse( localStorage.getItem( 'utm_details' ) || '{}' )
            } catch ( err ) {
                utmData = {}
            }

            for ( const utmField in utmObject ) {
                if ( !Object.hasOwn( utmObject, utmField ) ) continue
                const utmValue = utmObject[utmField]
                utmData[utmField] = utmValue
            }
            localStorage.setItem( "utm_details", JSON.stringify( utmData ) )
        }

    }, [searchParams] )

    return (
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", height: "100%", bgcolor: palette.layoutBackground }}>
            <Navbar />
            <Box sx={{ padding: "20px", flexGrow: 1, display: "flex", alignItems: "safe center", justifyContent: "center", overflow: "auto" }}>
                {mode === "registration" && <Box component={Paper} sx={{ borderRadius: "10px", padding: "20px", maxWidth: "550px" }}>
                    <Box component="form" id='pdetails' method='POST' onSubmit={handleRegister} >
                        <Box>
                            <Typography variant='h6' sx={{ fontSize: "1.6rem" }}>{t( 'candidateLogin.header' )}</Typography>
                            <Typography variant='subtitle2' color='textSecondary' sx={{ fontSize: "0.875rem" }}>{t( 'candidateLogin.subHeader' )}</Typography>
                        </Box>
                        <Box>
                            <FormControl margin='normal' fullWidth >
                                <Typography variant='subtitle2' gutterBottom component="label" htmlFor='registration-fullname'>{t( 'candidateLogin.fullName' )}</Typography>
                                <Box sx={{ display: "flex", border: border[1], borderRadius: 1, overflow: "clip", alignItems: "stretch", ":focus-within": { borderColor: "transparent", outline: `2px solid ${palette.primary.main}` } }} >
                                    <Typography color='textSecondary' sx={{ minWidth: "50px", width: "50px", bgcolor: palette.contentBg, display: "flex", alignItems: "center", justifyContent: "center", }}>
                                        {Icons.default.User}
                                    </Typography>
                                    <InputBase
                                        error={Boolean( errors.name )}
                                        onBlur={e => validateName( e.target.value )}
                                        onChange={handleNameChange}
                                        placeholder='Jhon Doe'
                                        type='text'
                                        value={name}
                                        sx={{
                                            flexGrow: 1,
                                            p: 0.5,
                                            px: 1,
                                        }}
                                        id='registration-fullname'
                                        size='small' />
                                </Box>
                                {errors.name && <Typography variant='subtitle2' color='error' sx={{ fontSize: "12px" }} > {errors.name}</Typography>}
                            </FormControl>
                            <FormControl margin='normal' fullWidth >
                                <Typography variant='subtitle2' component="label" htmlFor='registration-phno'>{t( 'candidateLogin.phNumber' )}</Typography>
                                <Typography color="textSecondary" sx={{ fontSize: "12px" }} gutterBottom >{t( 'candidateLogin.phNumberInfo' )}</Typography>
                                <Box sx={{ display: "flex", border: border[1], borderRadius: 1, overflow: "clip", alignItems: "stretch", ":focus-within": { borderColor: "transparent", outline: `2px solid ${palette.primary.main}` } }} >
                                    <Typography color='textSecondary' sx={{ minWidth: "50px", fontSize: "14px", fontWeight: 500, width: "50px", bgcolor: palette.contentBg, display: "flex", alignItems: "center", justifyContent: "center", }}>
                                        +998
                                    </Typography>
                                    <InputBase
                                        error={Boolean( errors.phoneNumber )}
                                        onBlur={e => validatePhoneNumber( e.target.value )}
                                        onChange={handlePhoneNumberChange}
                                        type='text'
                                        value={phone}
                                        placeholder='XXXXXXXXX'
                                        sx={{
                                            flexGrow: 1,
                                            p: 0.5,
                                            px: 1,
                                        }}
                                        id="registration-phno"
                                        size='small' />
                                </Box>
                                {errors.phoneNumber && <Typography variant='subtitle2' color='error' sx={{ fontSize: "12px" }} > {errors.phoneNumber}</Typography>}
                            </FormControl>
                            <FormControl margin='normal' fullWidth >
                                <Typography gutterBottom variant='subtitle2' component="label" htmlFor='registration-desired-program'>{t( 'candidateLogin.desiredProgramLabel' )}</Typography>
                                <Box sx={{ display: "flex", border: border[1], borderRadius: 1, overflow: "clip", alignItems: "stretch", ":focus-within": { borderColor: "transparent", outline: `2px solid ${palette.primary.main}` } }} >
                                    <Typography color='textSecondary' sx={{ minWidth: "50px", fontSize: "14px", fontWeight: 500, width: "50px", bgcolor: palette.contentBg, display: "flex", alignItems: "center", justifyContent: "center", }}>
                                        {Icons.default.School}
                                    </Typography>
                                    <Select
                                        onChange={( event ) => setProgram( event.target.value )}
                                        value={program}
                                        placeholder='Select program'
                                        sx={{
                                            flexGrow: 1,
                                            border: "none",
                                            outline: "none",
                                            "&.Mui-focused": {
                                                boxShadow: "none",
                                                border: "none",
                                                outline: "none"
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                border: "none"
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: "none"
                                            }
                                        }}
                                        slotProps={{
                                            input: {
                                                id: "registration-desired-program"
                                            }
                                        }}
                                        size='small'
                                    >
                                        {AVAILABLE_PROGRAMS.map( program => (
                                            <MenuItem sx={{ fontSize: "14px" }} key={program.value} value={program.value}>
                                                {program.label}
                                            </MenuItem>
                                        ) )}

                                    </Select>
                                </Box>
                                <Typography color="textSecondary" sx={{ fontSize: "12px" }} gutterBottom >** {t( 'candidateLogin.programSelectionInfo' )}</Typography>
                            </FormControl>
                        </Box>
                        <Box>
                            <Button type='submit' sx={{ mt: 2, textTransform: "capitalize", py: 1, px: 2 }} disableElevation startIcon={submitting ? <CircularProgress size={14} /> : Icons.default.Password} disabled={Boolean( submitting || errors.name || errors.phoneNumber )} size='small' variant='contained' >{submitting ? t( 'candidateLogin.submitting' ) : t( 'candidateLogin.submit' )}</Button>
                        </Box>
                    </Box>

                </Box>}

                {mode === "already-attempted" && <AlreadyAttempted handleReattemptRequest={handleReattemptRequest} waiting={submitting} />}

                {mode === "already-qualified" && <AlreadyQualified applicationNumber={modeData?.application_number || ""} programId={modeData?.program_id} />}

                {mode === "reattempt-requested" && <ReattemptRequested onBack={() => setMode( 'registration' )} />}

                {mode === "reattempt-approved" && <ReattemptRequestApproved onCta={handleRegister} waiting={submitting} />}

                {mode === "otp-verification" && <Box component={Paper} sx={{ borderRadius: "10px", padding: "20px", maxWidth: "550px" }}>
                    <Box component="form" id='otp-details' method='POST' onSubmit={handleOtpVerification} >
                        <Box>
                            <Typography variant='h6' sx={{ fontSize: "1.6rem" }}>{t( 'candidateLogin.otpVerificationHeader' )}</Typography>
                            <Typography variant='subtitle2' color='textSecondary' sx={{ fontSize: "0.875rem" }}>{t( 'candidateLogin.otpVerificationSubHeader' )} <Typography component="span" sx={{ fontSize: "0.875rem", fontWeight: "inherit", textDecoration: "underline" }}>+998{phone}</Typography>.</Typography>
                        </Box>
                        <Box>
                            <FormControl margin='normal' fullWidth >
                                <Typography variant='subtitle2' gutterBottom component="label" htmlFor='login-otp'>{t( 'candidateLogin.otpLabel' )}</Typography>
                                <Box sx={{ display: "flex", borderRadius: 1, overflow: "clip", alignItems: "stretch", gap: 1 }} >
                                    {[0, 1, 2, 3].map( ( i ) => (
                                        <TextField
                                            autoComplete='off'
                                            key={i}
                                            autoFocus={i === 0}
                                            slotProps={{
                                                input: {
                                                    id: `otp-input-${i}`
                                                }
                                            }}
                                            error={Boolean( errors.otp )}
                                            onChange={event => handleOtpChange( event, i )}
                                            placeholder='X'
                                            type='text'
                                            disabled={otpExpired}
                                            value={otp[i]}
                                            onFocus={event => event.target.select()}
                                            sx={{
                                                maxWidth: "38px"
                                            }}
                                            id='login-otp'
                                            size='small' />
                                    ) )}
                                </Box>
                                {errors.otp && <Typography variant='subtitle2' color='error' sx={{ fontSize: "12px" }} > {errors.otp}</Typography>}
                            </FormControl>

                            {verificationDetails.expires_at && <OTPExpiryTimer setOtpExpired={setOtpExpired} expiresAt={new Date( verificationDetails.expires_at )} />}

                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center", mt: 1 }} >
                                <Typography component="button" type="button"
                                    onClick={() => {
                                        setMode( "registration" )
                                        setOtp( ["", "", "", ""] )
                                    }}
                                    color='primary.light'
                                    sx={{
                                        border: "none",
                                        outline: "none",
                                        background: "none",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        fontSize: "0.875rem",
                                        ":focus": { outline: `1px solid ${palette.text.secondary}` }
                                    }}
                                >
                                    {t( 'candidateLogin.updateMobile' )}
                                </Typography>
                                <Typography onClick={requestOtpResend} component="button" type="button" color='primary.light' sx={{ border: "none", outline: "none", background: "none", cursor: "pointer", textDecoration: "underline", fontSize: "0.875rem", ":focus": { outline: `1px solid ${palette.text.secondary}` } }} >{otpExpired ? t( 'candidateLogin.regenerateOTP' ) : t( 'candidateLogin.resendOtp' )}</Typography>
                            </Box>

                        </Box>
                        <Box>
                            <Button type='submit' sx={{ mt: 2, textTransform: "capitalize", py: 1, px: 2 }} disableElevation startIcon={verifyingOtp ? <CircularProgress size={14} /> : Icons.default.CheckIcon} disabled={Boolean( verifyingOtp || errors.otp )} size='small' variant='contained' >{submitting ? t( 'candidateLogin.verifyingOtpBtn' ) : t( 'candidateLogin.verifyOtpBtn' )}</Button>
                        </Box>
                    </Box>

                </Box>}
            </Box>
        </Box>
    )
}
